import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { useTheme } from 'styled-components'

import { Metadata } from '../../typography/Metadata'
import Flex from '../Flex'
import ResponsiveSVG from '../ResponsiveSVG'

import { Success, SuccessRest, Warning } from 'images'

const FieldFeedback = ({ type, children, ...rest }) => {
  const { colors } = useTheme()

  const [Icon, color] = useMemo(() => {
    switch (type) {
      case 'success':
        return [Success, colors.grey6]
      case 'error':
        return [Warning, colors.error]
      default:
        return [SuccessRest, colors.grey6]
    }
  }, [type, colors])

  return (
    <Flex mt='4px' alignItems='center' {...rest}>
      <ResponsiveSVG
        SVG={Icon}
        mr='8px'
        width='15px'
        minHeight='15px'
        minWidth='15px'
        fill='primary'
        stroke='base'
      />
      <Metadata color={color}>{children}</Metadata>
    </Flex>
  )
}

FieldFeedback.defaultProps = {
  type: 'rest'
}

FieldFeedback.propTypes = {
  type: PropTypes.string,
  children: PropTypes.node
}

export default FieldFeedback
